import { Col, Row } from 'antd'
import { CopyToClipboard, WhiteSpace, WingBlank } from 'components'
import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import _ from 'lodash'
import { Flex } from 'antd-mobile'
import { intl, getCurrentLanguage } from 'utils'

// 订单有效期倒计时
// // ---------- 处理倒计时 start ----------
// renderCountDown = (props) => {
//   const { days, hours, minutes, seconds } = props
//   var str = ''
//   days && (str += `${days} days `)
//   hours && (str += `${hours} hours `)
//   minutes && (str += `${minutes} minutes `)
//   if (!days && !hours && !minutes && seconds) {
//     // 最后一分钟倒计时只显示秒
//     str += `${seconds} seconds `
//   }
//   return <span>{str}</span>
// }

// handleCountDownComplete = () => {
//   window.location.reload()
// }
// // ---------- 处理倒计时 end ----------
// {
//   orderInfo.expiredTime && this.state.activeKey !== '3' && (
//     <p className='font-12 text_secondary'>
//       Payment will be made in{' '}
//       <Countdown
//         date={orderInfo.expiredTime}
//         onComplete={this.handleCountDownComplete}
//         renderer={this.renderCountDown}
//       />
//     </p>
//   )
// }

class OrderInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      transactionDetailsVisible: false
    }
  }

  toggleTransactionDetailsVisible = async () => {
    this.setState((prevState) => ({
      transactionDetailsVisible: !prevState.transactionDetailsVisible,
    }))
  }

  render() {
    const {
      align,
      payInfo = {},
      payeeInfo = {},
      orderDesc,
      tradeSrcVoucherNo,
      orderNo,
      siteConfig,
      i18nExtension = {}
    } = this.props
    const currentLanguage = getCurrentLanguage()
    let merchantName

    if (currentLanguage === 'en') {
      merchantName = `${payeeInfo.payeeName}${orderDesc ? ' - ' + orderDesc : ''}`
    } else if (currentLanguage === 'ar') {
      if (i18nExtension.merchantName && i18nExtension.orderDesc) {
        merchantName = i18nExtension.merchantName.ar + ' - ' + i18nExtension.orderDesc.ar
      } else if (i18nExtension.merchantName && !i18nExtension.orderDesc) {
        merchantName = `${i18nExtension.merchantName.ar}${orderDesc ? ' - ' + orderDesc : ''}`
      } else if (!i18nExtension.merchantName && i18nExtension.orderDesc) {
        merchantName = payeeInfo.payeeName + ' - ' + i18nExtension.orderDesc.ar
      } else {
        merchantName = `${payeeInfo.payeeName}${orderDesc ? ' - ' + orderDesc : ''}`
      }
    }
    const merchantLogo =
      _.get(siteConfig, 'pageCustomize.logoUrl') ||
      payeeInfo.payeeLogoUrl
    if (align === 'center') {
      return (
        <div className={`${classes.payPageComponentsOrderInfo} text-center`}>
          <div
            className={classes.merchantIcon}
            style={{
              width: '80px',
              height: '80px',
              backgroundImage: `url(${merchantLogo})`,
            }}
          />
          <WhiteSpace size='sm' />
          <WingBlank>
            <div className={classes.merchantName} title={merchantName}>
              {merchantName}
            </div>
          </WingBlank>
          <WhiteSpace size='md' />
          <div className={classes.transactionAmountText}>
            <span className='text_secondary'>{intl().formatMessage(messages.TransactionAmount)}</span>
          </div>
          <WhiteSpace size='sm' />
          <div className={classes.amount}>
            {payInfo.currencyIcon && <img src={payInfo.currencyIcon} width='16' />}{' '}
            <b>
              {_.get(payInfo, 'payAmount.currency')} {_.get(payInfo, 'payAmount.amount')}
            </b>
          </div>
          <WhiteSpace size='xl' />
          {/* 添加优惠券功能后才显示折扣金额 */}
          {/* <WhiteSpace size='xs' />
          <div className='text-line-through'>{handleAmount(orderAmount)}</div> */}
          <WingBlank className='text_secondary font-12'>
            <WhiteSpace />
            <span
              className={`${classes.transactionDetailsToggler} ${
                this.state.transactionDetailsVisible ? classes.active : ''
              }`}
              onClick={this.toggleTransactionDetailsVisible}
            >
              {intl().formatMessage(messages.TransactionDetails)}
              <b className='iconfont iconarrow-right-small' />
            </span>
            <WhiteSpace size='md' />
            <div
              className={`${classes.transactionDetailsContainer} ${
                this.state.transactionDetailsVisible ? classes.active : ''
              }`}
            >
              <Flex>
                <span className='text-left'>
                  {intl().formatMessage(messages.MerchantOrderNo)}
                </span>
                <Flex.Item className='text-right'>
                  <CopyToClipboard>{tradeSrcVoucherNo}</CopyToClipboard>
                </Flex.Item>
              </Flex>
              <WhiteSpace size='sm' />
              <Flex>
                <span className='text-left'>
                  {intl().formatMessage(messages.OrderNo)}
                </span>
                <Flex.Item className='text-right'>
                  <CopyToClipboard>{orderNo}</CopyToClipboard>
                </Flex.Item>
              </Flex>
            </div>
            <WhiteSpace size='md' />
          </WingBlank>
        </div>
      )
    }
    return (
      <div className={classes.payPageComponentsOrderInfo}>
        <div className={classes.merchantName} title={merchantName}>
          {merchantName}
        </div>
        <WhiteSpace size='xl' />
        <Row>
          <Col span={20}>
            <div
              className={classes.merchantIcon}
              style={{
                width: '96px',
                height: '96px',
                backgroundImage: `url(${merchantLogo})`,
              }}
            />
          </Col>
          {/* 添加商品列表后才后商品数量 */}
          {/* <Col span={4}>
            <div className='text-right font-12' style={{ lineHeight: '48px' }}>
              <b>3 Items</b>
            </div>
          </Col> */}
        </Row>
        <WhiteSpace />
        <Row>
          <Col span={8}>
            <div className='text_secondary font-12' style={{ lineHeight: '30px' }}>
              {intl().formatMessage(messages.TotalAmount)}
            </div>
          </Col>
          <Col span={16} className='text-right'>
            <b className='font-14' style={{ verticalAlign:'5px' }}>
              {_.get(payInfo, 'payAmount.currency')}{' '}
            </b>
            <b className='font-30'>{_.get(payInfo, 'payAmount.amount')}</b>
          </Col>
        </Row>
        {/* 添加优惠券功能后才显示折扣金额 */}
        {/* <WhiteSpace size='sm' />
        <div className='text-line-through text-right'>AED 256.91</div> */}
        <div className='text_secondary font-12'>
          <WhiteSpace size='md' />
          <div className='text-center'>
            <span
              className={`${classes.transactionDetailsToggler} ${
                this.state.transactionDetailsVisible ? classes.active : ''
              }`}
              onClick={this.toggleTransactionDetailsVisible}
            >
              {intl().formatMessage(messages.TransactionDetails)}
              <b className='iconfont iconarrow-right-small' />
            </span>
          </div>
          <WhiteSpace size='md' />
          <div
            className={`${classes.transactionDetailsContainer} ${
              this.state.transactionDetailsVisible ? classes.active : ''
            }`}
          >
            <Flex>
              <span className='text-left'>
                {intl().formatMessage(messages.MerchantOrderNo)}
              </span>
              <Flex.Item className='text-right'>
                <CopyToClipboard>{tradeSrcVoucherNo}</CopyToClipboard>
              </Flex.Item>
            </Flex>
            <WhiteSpace size='sm' />
            <Flex>
              <span className='text-left'>
                {intl().formatMessage(messages.OrderNo)}
              </span>
              <Flex.Item className='text-right'>
                <CopyToClipboard>{orderNo}</CopyToClipboard>
              </Flex.Item>
            </Flex>
          </div>
        </div>
        <WhiteSpace size='md' />
        <hr />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig
  }),
  {}
)(OrderInfo)
